import { Entity } from '@backstage/catalog-model'

export const BACKSTAGE_SOURCE_LOCATION_ANNOTATION = 'backstage.io/source-location'
export const BACKSTAGE_MANAGED_BY_LOCATION_ANNOTATION = 'backstage.io/managed-by-location'

export interface GithubRepoRef {
  owner: string
  repo: string
}

const parseGithubLocation = (value: string): GithubRepoRef | null => {
  const separator = value.indexOf(':')
  if (separator <= 0) return null
  const scheme = value.slice(0, separator)
  if (scheme !== 'url') return null

  let url: URL
  try {
    url = new URL(value.slice(separator + 1))
  } catch {
    return null
  }
  if (url.hostname !== 'github.com') return null

  const [owner, repo] = url.pathname.split('/').filter(Boolean)
  if (!owner || !repo) return null
  return { owner, repo: repo.replace(/\.git$/, '') }
}

/**
 * Infer the GitHub `{ owner, repo }` for an entity from the location annotations
 * that `GithubEntityProvider` auto-populates (`backstage.io/source-location`, falling
 * back to `backstage.io/managed-by-location`). Returns `null` when no usable
 * github.com URL is present so callers can decide how to surface the absence.
 */
export const extractGithubRepoFromEntity = (entity: Entity): GithubRepoRef | null => {
  const annotations = entity.metadata.annotations ?? {}
  const locationValue =
    annotations[BACKSTAGE_SOURCE_LOCATION_ANNOTATION] ?? annotations[BACKSTAGE_MANAGED_BY_LOCATION_ANNOTATION]
  if (!locationValue) return null
  return parseGithubLocation(locationValue)
}
